import { render, staticRenderFns } from "./company_reg.vue?vue&type=template&id=aa19d5dc&scoped=true&"
import script from "./company_reg.vue?vue&type=script&lang=js&"
export * from "./company_reg.vue?vue&type=script&lang=js&"
import style0 from "./company_reg.vue?vue&type=style&index=0&id=aa19d5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa19d5dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('aa19d5dc', component.options)
    } else {
      api.reload('aa19d5dc', component.options)
    }
    module.hot.accept("./company_reg.vue?vue&type=template&id=aa19d5dc&scoped=true&", function () {
      api.rerender('aa19d5dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/company/company_reg.vue"
export default component.exports